// import { useTranslation } from "react-i18next"
import * as Yup from "yup"
import i18n from "../../i18n"
import { TFunction } from "i18next"

const { string, object } = Yup
// const { t, i18n } = useTranslation()

export const LoginPanelValidationSchema = object().shape({
    username: string().email(i18n.t("login.help.email", "Bitte gib eine gültige Emailadresse ein")).required(i18n.t("login.help.email", "Bitte gib deine E-Mail-Adresse ein")),
    password: string().required(i18n.t("login.help.password", "Das Passwortfeld darf nicht leer sein")),
})

export const buildLoginPanelValidationSchema = (t: TFunction) => {
    return object().shape({
        username: string().email(t("login.help.email", "Bitte gib eine gültige Emailadresse ein")).required(t("login.help.email", "Bitte gib deine E-Mail-Adresse ein")),
        password: string().required(t("login.help.password", "Das Passwortfeld darf nicht leer sein")),
    })
}
